// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    construction_find_works: 'Buscando entre las obras',
    construction_work_status: 'Leyendo cómo va la obra',
    construction_work_deviations: 'Buscando lo que se pasa de presupuesto',
    construction_pending_certifications: 'Mirando las certificaciones pendientes',
    construction_subcontract_status: 'Mirando las subcontratas',
    construction_works_summary: 'Sumando las obras',
  },
  ca: {
    construction_find_works: 'Cercant entre les obres',
    construction_work_status: 'Llegint com va l’obra',
    construction_work_deviations: 'Buscant el que supera el pressupost',
    construction_pending_certifications: 'Mirant les certificacions pendents',
    construction_subcontract_status: 'Mirant les subcontractes',
    construction_works_summary: 'Sumant les obres',
  },
  en: {
    construction_find_works: 'Looking through the works',
    construction_work_status: 'Reading how the work is going',
    construction_work_deviations: 'Looking for what is going over budget',
    construction_pending_certifications: 'Looking at the certifications still open',
    construction_subcontract_status: 'Looking at the subcontracts',
    construction_works_summary: 'Adding up the works',
  },
  fr: {
    construction_find_works: 'Recherche parmi les chantiers',
    construction_work_status: 'Lecture de l’avancement du chantier',
    construction_work_deviations: 'Recherche des dépassements de budget',
    construction_pending_certifications: 'Consultation des situations de travaux en cours',
    construction_subcontract_status: 'Consultation des sous-traitances',
    construction_works_summary: 'Total des chantiers',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
